import { AlertCircleOutlinedIcon } from '@weblite/icons'
import { Typography } from '@mui/material'
import { CompatibilityWarningLayout } from '$common/compatibility-warning-layout'
import { IS_IOS } from '$func/environmentInfo'
import { t } from '$i18n'

export function OutDatedOs({ isOpen }: { isOpen: boolean }) {
  return (
    <CompatibilityWarningLayout
      isOpen={isOpen}
      icon={<img src="assets/icons/android-logo.svg" />}
      title={t(`warningPages.outdatedOs.${IS_IOS ? 'oldIos' : 'oldAndroid'}`)}
      description={
        <>
          <Typography textAlign="center" variant="paragraph1">
            {t(
              `warningPages.outdatedOs.${IS_IOS ? 'updateIos' : 'updateAndroid'}`,
            )}
          </Typography>
        </>
      }
      badge={
        <AlertCircleOutlinedIcon
          sx={{ color: 'neutral000', width: '40px', height: '40px' }}
        />
      }
    />
  )
}
